import {
  analysisCardImg1,
  analysisCardImg2,
  analysisCardImg3,
  analysisCardImg4,
  surveyPlaceholderImg,
} from "assets/images";
import React, { useEffect, useState } from "react";
import { IoIosTrendingDown, IoIosTrendingUp } from "react-icons/io";
import "./Analysis.scss";
import SurveyChart from "./section/SurveyChart";
import DistributionChart from "./section/DistributionChart";
import SummeryTable from "./section/SummeryTable";
import MySurveyShrimmer from "shrimmer/Survey/MySurveyShrimmer";
import useShimmer from "hooks/useShrimmer";
import { dashboardsDataApi } from "services/analysis";
import { getFromLocal } from "config/axiosInstance";
import NotFoundPlaceHolder from "components/not-found/NotFoundPlaceHolder";
import { useTranslation } from "react-i18next";

const Analysis = () => {
  //********************** Handle All State *******************//

  const [leftChartValue, setLeftChartValue] = useState({});
  const [rightChartValue, setRightChartValue] = useState();
  const [analysisCardsValue, setAnalysisCardsValue] = useState({});
  const [analysisListRecord, setSAnalysisListRecord] = useState([]);

  const [showShimmer, setShowShimmer] = useShimmer(MySurveyShrimmer);
  const { t } = useTranslation();

  //********************* Handle All Functions ******************//

  // Fetch Dashboard and Chart Data Handler
  const fetchSurveyListHandler = async () => {
    try {
      setShowShimmer(true);
      const reqData = {
        token: getFromLocal(),
      };
      const responseData = await dashboardsDataApi(reqData);
      const { status, data } = responseData;
      if (status === 200) {
        let { dashboardData } = data?.researcherDashboard || {};
        setAnalysisCardsValue(dashboardData);
        let leftChartDataClone =
          data?.researcherDashboard?.surveyCategoryPercentages
            ?.filter((el) => el?.value > 0)
            ?.map((el) => el) || [];
        let rightChartDataClone =
          data?.researcherDashboard?.surveyRegionPercentages
            ?.filter((el) => el?.value > 0)
            ?.map((el) => el) || [];
        setLeftChartValue(leftChartDataClone);
        setRightChartValue(rightChartDataClone);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  // useEffect for get analysis and chart and list data
  useEffect(() => {
    fetchSurveyListHandler();
  }, []);

  //********************** Handle HTML CODE *******************//
  return (
    <>
      <div className="analysis">
        <h3 className="dashboard_title">
          {t("SURVEY_ANALYSIS.surveyAnalysis")}
        </h3>
        <div className="analysis_card_wrap">
          <div className="analysis_card">
            <div className="content">
              <p>{t("SURVEY_ANALYSIS.totalSurvey")}</p>
              <p>
                <b>{analysisCardsValue?.totalSurveys?.value}</b>
              </p>

              <p>
                <span
                  className={
                    analysisCardsValue?.totalSurveys?.change?.isPositive
                      ? "green"
                      : "red"
                  }
                >
                  {analysisCardsValue?.totalSurveys?.change?.isPositive ? (
                    <IoIosTrendingUp />
                  ) : (
                    <IoIosTrendingDown />
                  )}
                  {`${analysisCardsValue?.totalSurveys?.change?.value?.toFixed(
                    2
                  )}%`}
                </span>{" "}
                {analysisCardsValue?.totalSurveys?.change?.isPositive
                  ? t("SURVEY_ANALYSIS.up")
                  : t("SURVEY_ANALYSIS.down")}
                {t("SURVEY_ANALYSIS.fromYesterday")}
              </p>
            </div>

            <img src={analysisCardImg1} alt="" />
          </div>

          <div className="analysis_card">
            <div className="content">
              <p>{t("SURVEY_ANALYSIS.ongoingSurvey")}</p>
              <p>
                <b>{analysisCardsValue?.ongoingSurveys?.value || 0}</b>
              </p>

              <p>
                <span
                  className={
                    analysisCardsValue?.ongoingSurveys?.change?.isPositive
                      ? "green"
                      : "red"
                  }
                >
                  {analysisCardsValue?.ongoingSurveys?.change?.isPositive ? (
                    <IoIosTrendingUp />
                  ) : (
                    <IoIosTrendingDown />
                  )}
                  {`${analysisCardsValue?.ongoingSurveys?.change?.value}%`}
                </span>{" "}
                {analysisCardsValue?.ongoingSurveys?.change?.isPositive
                  ? t("SURVEY_ANALYSIS.up")
                  : t("SURVEY_ANALYSIS.down")}
                {t("SURVEY_ANALYSIS.fromPastWeek")}
              </p>
            </div>
            <img src={analysisCardImg2} alt="" />
          </div>

          <div className="analysis_card">
            <div className="content">
              <p>{t("SURVEY_ANALYSIS.completeSurvey")}</p>
              <p>
                <b>{analysisCardsValue?.completedSurveys?.value || 0}</b>
              </p>

              <p>
                <span
                  className={
                    analysisCardsValue?.completedSurveys?.change?.isPositive
                      ? "green"
                      : "red"
                  }
                >
                  {analysisCardsValue?.completedSurveys?.change?.isPositive ? (
                    <IoIosTrendingUp />
                  ) : (
                    <IoIosTrendingDown />
                  )}
                  {`${analysisCardsValue?.completedSurveys?.change?.value}%`}
                </span>{" "}
                {analysisCardsValue?.completedSurveys?.change?.isPositive
                  ? t("SURVEY_ANALYSIS.up")
                  : t("SURVEY_ANALYSIS.down")}
                {t("SURVEY_ANALYSIS.fromYesterday")}
              </p>
            </div>
            <img src={analysisCardImg3} alt="" />
          </div>

          <div className="analysis_card">
            <div className="content">
              <p>{t("SURVEY_ANALYSIS.rewardDistributed")}</p>
              <p>
                <b>{analysisCardsValue?.rewardsDistributed?.value || 0}</b>
              </p>

              <p>
                <span
                  className={
                    analysisCardsValue?.rewardsDistributed?.change?.isPositive
                      ? "green"
                      : "red"
                  }
                >
                  {analysisCardsValue?.rewardsDistributed?.change
                    ?.isPositive ? (
                    <IoIosTrendingUp />
                  ) : (
                    <IoIosTrendingDown />
                  )}
                  {`${analysisCardsValue?.rewardsDistributed?.change?.value}%`}
                </span>{" "}
                {analysisCardsValue?.rewardsDistributed?.change?.isPositive
                  ? t("SURVEY_ANALYSIS.up")
                  : t("SURVEY_ANALYSIS.down")}
                {t("SURVEY_ANALYSIS.fromYesterday")}
              </p>
            </div>
            <img src={analysisCardImg4} alt="" />
          </div>
        </div>

        <div className="chart_wrap">
          {leftChartValue?.length > 0 ? (
            <SurveyChart leftChartData={leftChartValue} />
          ) : (
            <NotFoundPlaceHolder
              title={t("SURVEY_ANALYSIS.surveyCategoryNotFound")}
              className="mySurveyList"
              placeHolderImage={surveyPlaceholderImg}
            />
          )}

          {rightChartValue?.length > 0 ? (
            <DistributionChart rightChartData={rightChartValue} />
          ) : (
            <NotFoundPlaceHolder
              title={t("SURVEY_ANALYSIS.distributedRegionNotFound")}
              className="mySurveyList"
              placeHolderImage={surveyPlaceholderImg}
            />
          )}
        </div>

        <SummeryTable />
      </div>
    </>
  );
};
export default Analysis;
